/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Find_Answers_KnowledgeInputs */



/**
* | output |
* | --- |
* | "Find answers in company knowledge" |
*
* @param {Onboarding_Usage_Find_Answers_KnowledgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_find_answers_knowledge = /** @type {((inputs?: Onboarding_Usage_Find_Answers_KnowledgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Find_Answers_KnowledgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Antworten im Unternehmenswissen finden")
	return /** @type {LocalizedString} */ ("Find answers in company knowledge")
});